import { Fragment } from "react";
import { motion } from "framer-motion";
import LazyLoadingImg from "../Components/LazyLoadingImg";
import useWindowWidth from "../../hooks/useWindowWidth";

// Reusable motion wrapper
const MotionSwitch = ({
  isMobile,
  as = "div",
  className,
  children,
  initial,
  inView,
  transition,
  ...rest
}) => {
  const Tag = as;
  if (!isMobile) {
    return (
      <Tag className={className} {...rest}>
        {children}
      </Tag>
    );
  }
  const MotionTag = motion[as] ?? motion.div;
  return (
    <MotionTag
      className={className}
      initial={initial}
      whileInView={inView}
      viewport={{ once: true, amount: 0.5, margin: "0px 0px -15% 0px" }}
      transition={transition ?? { duration: 0.6, ease: "easeOut" }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};

export default function SprigStackSolution() {
  const width = useWindowWidth();
  const isMobile = width <= 600;

  return (
    <Fragment>
      <div className="container-fluid horizontal-padding">
        <div className="row mx-0">
          {/* Left Column */}
          <div className="col-lg-6 col-md-6 col-12 px-0 align-content-center">
            {/* Heading: slide from top */}
            <MotionSwitch
              isMobile={isMobile}
              as="h2"
              className="a2-font-3 mb-3"
              initial={{ opacity: 0, y: -40 }}
              inView={{ opacity: 1, y: 0 }}
            >
              SprigStack Solution
            </MotionSwitch>

            <ul className="a2-font-ul-4">
              {/* First li: left → right */}
              <MotionSwitch
                isMobile={isMobile}
                as="li"
                initial={{ opacity: 0, x: -50 }}
                inView={{ opacity: 1, x: 0 }}
              >
                To fulfill client expectations and to tackle challenges in CRM
                development, our team developed a robust CRM solution. Utilizing
                Angular, ASP.NET Core APIs, and SQL, we introduced features for
                seamless integration, automation, and payment gateways.
              </MotionSwitch>

              {/* Second li: right → left */}
              <MotionSwitch
                isMobile={isMobile}
                as="li"
                initial={{ opacity: 0, x: 50 }}
                inView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, ease: "easeOut", delay: 0.1 }}
              >
                The updated theme aligns with market trends while addressing
                challenges such as email scheduling and simplifying email
                marketing for a more user-friendly CRM.
              </MotionSwitch>
            </ul>
          </div>

          {/* Right Column (Image) */}
          <div className="col-lg-6 col-md-6 col-12 px-0">
            <MotionSwitch
              isMobile={isMobile}
              initial={{ opacity: 0, y: 50 }}
              inView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, ease: "easeOut" }}
              className="w-100 h-100 d-flex justify-content-center align-items-center"
            >
              <LazyLoadingImg
                src="/images/a2-sprigstack-solution.png"
                alt="a2-portfolio-overview"
                className="img-fluid"
              />
            </MotionSwitch>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
